import { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'

export default function VNCViewer() {
  const { resourceId } = useParams<{ resourceId: string }>()
  const containerRef = useRef<HTMLDivElement>(null)
  const [status, setStatus] = useState<'connecting' | 'connected' | 'disconnected'>('connecting')

  useEffect(() => {
    if (!containerRef.current || !resourceId) return

    // noVNC dynamically loaded — it expects a WebSocket URL.
    // The Session Gateway bridges RFB over WebSocket.
    const wsUrl = `wss://${window.location.host}/session/vnc?resource_id=${resourceId}`

    // TODO: initialize noVNC RFB client here when novnc is bundled.
    // import RFB from '@novnc/novnc/core/rfb'
    // const rfb = new RFB(containerRef.current, wsUrl)
    // rfb.addEventListener('connect', () => setStatus('connected'))
    // rfb.addEventListener('disconnect', () => setStatus('disconnected'))
    // return () => rfb.disconnect()

    // Stub: show connection info.
    setStatus('connecting')
    const ws = new WebSocket(wsUrl)
    ws.onopen = () => setStatus('connected')
    ws.onclose = () => setStatus('disconnected')
    return () => ws.close()
  }, [resourceId])

  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="flex items-center gap-3 border-b border-border bg-surface px-4 py-2 text-sm">
        <span
          className={`inline-block h-2 w-2 rounded-full ${
            status === 'connected' ? 'bg-success' : 'bg-warning animate-pulse'
          }`}
        />
        <span className="capitalize text-foreground">{status}</span>
        <span className="text-muted">VNC — {resourceId}</span>
      </div>
      {/* Mount container — thin stub; keep flex-1 black surface for future noVNC */}
      <div
        ref={containerRef}
        className="flex flex-1 items-center justify-center bg-black text-sm text-muted"
      >
        {status === 'connecting' && <span className="animate-pulse">Connecting to VNC...</span>}
        {status === 'connected' && <span>VNC session active (noVNC canvas here)</span>}
        {status === 'disconnected' && <span>Disconnected</span>}
      </div>
    </div>
  )
}
